const SIDES = ['top', 'right', 'bottom', 'left']

const measurement = (value, name, allowZero = true) => {
  if (
    typeof value !== 'number' ||
    !Number.isFinite(value) ||
    value < 0 ||
    (!allowZero && value === 0)
  ) {
    throw new Error(
      `${name} must be a finite ${allowZero ? 'nonnegative' : 'positive'} measurement in inches.`,
    )
  }
  return value
}

const borders = (value, name) =>
  Object.fromEntries(
    SIDES.map((side) => [
      side,
      measurement(typeof value === 'number' ? value : value?.[side], `${name} ${side}`),
    ]),
  )

// All rectangles use inches, including the SVG viewBox. Screen fitting never
// changes the relative sizes of the print, mat, and moulding.
export const calculateFramingDimensions = ({ printWidth, printHeight, matBorders, frameWidth }) => {
  measurement(printWidth, 'Print width', false)
  measurement(printHeight, 'Print height', false)
  const mat = borders(matBorders, 'Mat')
  const frame = borders(frameWidth, 'Frame')
  const matWidth = printWidth + mat.left + mat.right
  const matHeight = printHeight + mat.top + mat.bottom
  const outerWidth = matWidth + frame.left + frame.right
  const outerHeight = matHeight + frame.top + frame.bottom
  measurement(outerWidth, 'Outside width', false)
  measurement(outerHeight, 'Outside height', false)
  return {
    printWidth,
    printHeight,
    mat,
    frame,
    matWidth,
    matHeight,
    outerWidth,
    outerHeight,
    artwork: {
      x: frame.left + mat.left,
      y: frame.top + mat.top,
      width: printWidth,
      height: printHeight,
    },
    mount: { x: frame.left, y: frame.top, width: matWidth, height: matHeight },
  }
}

export const calculateFrameEdges = ({ outerWidth: w, outerHeight: h, frame: f }) => [
  {
    side: 'left',
    width: f.left,
    length: h,
    points: `0,0 ${f.left},${f.top} ${f.left},${h - f.bottom} 0,${h}`,
    transform: 'matrix(1 0 0 1 0 0)',
  },
  {
    side: 'top',
    width: f.top,
    length: w,
    points: `0,0 ${w},0 ${w - f.right},${f.top} ${f.left},${f.top}`,
    transform: `matrix(0 1 -1 0 ${w} 0)`,
  },
  {
    side: 'right',
    width: f.right,
    length: h,
    points: `${w},0 ${w},${h} ${w - f.right},${h - f.bottom} ${w - f.right},${f.top}`,
    transform: `matrix(-1 0 0 -1 ${w} ${h})`,
  },
  {
    side: 'bottom',
    width: f.bottom,
    length: w,
    points: `0,${h} ${f.left},${h - f.bottom} ${w - f.right},${h - f.bottom} ${w},${h}`,
    transform: `matrix(0 -1 1 0 0 ${h})`,
  },
]

export const formatInches = (value) => Number(value.toFixed(4)).toString()
